export const breakpoints = {
  /**400px*/
  0: "400px",
  /**610px*/
  1: "610px",
  /**700px*/
  2: "700px",
  /**900px*/
  3: "900px",
  /**1024px*/
  4: "1024px",
  /**1220px*/
  5: "1220px",
  /**1332px*/
  6: "1332px",
  /**1440px*/
  7: "1440px",
  /**1920px*/
  8: "1920px",
};
